import * as type from "../types";

export const setSelectedToOrganization = (organization) => ({
  type: type.SET_SELECTED_TO_ORGANIZATION,
  payload: organization,
});

export const getCertificatesRequest = (reqParams) => ({
  type: type.GET_CERTIFICATES_REQUEST,
  payload: reqParams,
});

export const getCertificatesSucceeded = (data) => ({
  type: type.GET_CERTIFICATES_SUCCEEDED,
  payload: data,
});

export const getCertificatesFailed = () => ({
  type: type.GET_CERTIFICATES_FAILED,
});

export const getBilateralAgreementsRequest = (organizationId) => ({
  type: type.GET_BILATERAL_AGREEMENTS_REQUEST,
  payload: organizationId,
});

export const getBilateralAgreementsSucceeded = (data) => ({
  type: type.GET_BILATERAL_AGREEMENTS_SUCCEEDED,
  payload: data,
});

export const getBilateralAgreementsFailed = () => ({
  type: type.GET_BILATERAL_AGREEMENTS_FAILED,
});

export const getBilateralAgreementsHistoryRequest = (reqParams) => ({
  type: type.GET_BILATERAL_AGREEMENTS_HISTORY_REQUEST,
  payload: reqParams,
});

export const getBilateralAgreementsHistorySucceeded = (data) => ({
  type: type.GET_BILATERAL_AGREEMENTS_HISTORY_SUCCEEDED,
  payload: data,
});

export const getBilateralAgreementsHistoryFailed = () => ({
  type: type.GET_BILATERAL_AGREEMENTS_HISTORY_FAILED,
});

export const setSelectedSellerOrganization = (organization) => ({
  type: type.SET_SELECTED_SELLER_ORGANIZATION,
  payload: organization,
});
export const setSelectedDateWithOrganization = (organization) => ({
  type: type.SET_SELECTED_DATE_WITH_ORGANIZATION,
  payload: organization,
});

export const setSelectedBuyerOrganization = (organization) => ({
  type: type.SET_SELECTED_BUYER_ORGANIZATION,
  payload: organization,
});
